import type { CartLine, CartState } from './types'
import { initialCartState } from './reducer'

const STORAGE_KEY_PREFIX = 'qr-menu-cart:'

function isCartLine(value: unknown): value is CartLine {
  if (typeof value !== 'object' || value === null) return false
  const line = value as Record<string, unknown>
  return (
    typeof line.menuItemId === 'number' &&
    typeof line.name === 'string' &&
    typeof line.unitPriceCents === 'number' &&
    typeof line.quantity === 'number' &&
    (line.imageThumbnail === null || typeof line.imageThumbnail === 'string')
  )
}

function isCartState(value: unknown): value is CartState {
  if (typeof value !== 'object' || value === null) return false
  const state = value as Record<string, unknown>
  return Array.isArray(state.lines) && state.lines.every(isCartLine)
}

export function loadCart(slug: string): CartState {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY_PREFIX + slug)
    if (!raw) return initialCartState
    const parsed = JSON.parse(raw)
    return isCartState(parsed) ? parsed : initialCartState
  } catch {
    return initialCartState
  }
}

export function saveCart(slug: string, state: CartState): void {
  try {
    sessionStorage.setItem(STORAGE_KEY_PREFIX + slug, JSON.stringify(state))
  } catch {
    // sessionStorage can throw (quota, private browsing) — the cart still
    // works in-memory for the rest of this page session.
  }
}
